import React from "react";

const Paragraph = ({ variant, children, className = "" }) => {
  return (
    <>
     

      {/* Latest Paragraphs Specifications */}

      {/* o	Usage: Default style for all main content */}
      {variant === "MainParagraph" && (
        <p
          className={`
          ${className} body-standard font-inter`}
        >
          {children}
        </p>
      )}

    {variant === "BodyCompact" && (
        <p
          className={`
          ${className} body-standard font-inter`}
        >
          {children}
        </p>
      )}

      {variant === "BodyDense" && (
        <p
          className={`
          ${className} font-inter`}
        >
          {children}
        </p>
      )}

      {variant === "BodySmall" && (
        <p
          className={`
          ${className} font-inter`}
        >
          {children}
        </p>
      )}

      {variant === "BodyMeta" && (
        <p
          className={`
          ${className} font-inter`}
        >
          {children}
        </p>
      )}

      {variant === "Legal" && (
        <p
          className={`
          ${className} legal-fine-print font-inter`}
        >
          {children}
        </p>
      )}

      {/* o	Usage: Styling for footer sub text/paragraph  */}
      {variant === "FooterParagraph" && (
        <p
          className={`
          ${className} footer-text font-inter capitalize`}
        >
          {children}
        </p>
      )}
    </>
  );
};
export default Paragraph;
